export class MeganavKeyboard {
  constructor({ getMeganavTargets, getMeganavMenuTargets, hideMeganavs, expandMeganav }) {
    this.getMeganavTargets = getMeganavTargets;
    this.getMeganavMenuTargets = getMeganavMenuTargets;
    this.hideMeganavs = hideMeganavs;
    this.expandMeganav = expandMeganav;
  }

  handleTriggerKeydown(event) {
    const anchor = event.currentTarget;
    const menuItem = anchor.closest('.meganav-menu');
    const meganavType = menuItem?.dataset.meganav;
    const active = menuItem?.dataset.active === 'true';

    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      if (!active && meganavType) {
        this.expandMeganav(anchor, menuItem, meganavType);
      }
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (!active && meganavType) {
        this.expandMeganav(anchor, menuItem, meganavType);
        setTimeout(() => this.focusFirstDropdownItem(meganavType), 150);
      } else if (active && meganavType) {
        setTimeout(() => this.focusFirstDropdownItem(meganavType), 0);
      }
    } else if (event.key === 'Escape' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (active) {
        this.hideMeganavs();
        anchor.focus();
      }
    }
  }

  handleDropdownKeydown(event, meganavType) {
    const dropdownLinks = this.getDropdownLinks(meganavType);
    if (dropdownLinks.length === 0) return;

    const currentLinkIndex = dropdownLinks.indexOf(event.currentTarget);

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      const nextLinkIndex = currentLinkIndex < dropdownLinks.length - 1 ? currentLinkIndex + 1 : currentLinkIndex;
      dropdownLinks[nextLinkIndex].focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (currentLinkIndex === 0) {
        this.returnFocusToMenu(meganavType);
      } else {
        dropdownLinks[currentLinkIndex - 1].focus();
      }
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.navigateToAdjacentColumn(meganavType, event.currentTarget, 'next');
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.navigateToAdjacentColumn(meganavType, event.currentTarget, 'prev');
    } else if (event.key === 'Escape') {
      event.preventDefault();
      this.hideMeganavs();
      this.returnFocusToMenu(meganavType);
    }
  }

  getActiveMeganav(meganavType) {
    return this.getMeganavTargets().find((meganavElement) =>
      meganavElement.dataset.meganav === meganavType && meganavElement.style.display !== 'none'
    );
  }

  getDropdownLinks(meganavType) {
    const activeMeganav = this.getActiveMeganav(meganavType);
    if (!activeMeganav) return [];

    return Array.from(activeMeganav.querySelectorAll('a[href]')).filter((link) => {
      const href = link.getAttribute('href');
      const id = link.getAttribute('id');
      return href && href !== '#' && href !== '' && !id?.includes('close-');
    });
  }

  getMenuAnchor(meganavType) {
    const activeMenu = this.getMeganavMenuTargets().find((menuItem) => menuItem.dataset.meganav === meganavType);
    return activeMenu?.querySelector('a[href="#"]');
  }

  returnFocusToMenu(meganavType) {
    const menuAnchor = this.getMenuAnchor(meganavType);
    if (menuAnchor) menuAnchor.focus();
  }

  setupDropdownKeyboardNavigation(meganavType) {
    setTimeout(() => {
      const dropdownLinks = this.getDropdownLinks(meganavType);

      dropdownLinks.forEach((link) => {
        if (link._dropdownKeydownHandler) {
          link.removeEventListener('keydown', link._dropdownKeydownHandler);
        }

        const handler = (event) => this.handleDropdownKeydown(event, meganavType);
        link._dropdownKeydownHandler = handler;
        link.addEventListener('keydown', handler);
      });
    }, 150);
  }

  removeDropdownKeyboardHandlers() {
    this.getMeganavTargets().forEach((meganavElement) => {
      const dropdownLinks = meganavElement.querySelectorAll('a[href]');
      dropdownLinks.forEach((link) => {
        if (link._dropdownKeydownHandler) {
          link.removeEventListener('keydown', link._dropdownKeydownHandler);
          delete link._dropdownKeydownHandler;
        }
      });
    });
  }

  focusFirstDropdownItem(meganavType) {
    const dropdownLinks = this.getDropdownLinks(meganavType);

    if (dropdownLinks.length > 0) {
      dropdownLinks[0].focus();
      this.setupDropdownKeyboardNavigation(meganavType);
    }
  }

  getColumns(meganavType) {
    const activeMeganav = this.getActiveMeganav(meganavType);
    if (!activeMeganav) return [];

    return Array.from(activeMeganav.querySelectorAll(
      '.discover-meganav-columns, .learn-meganav-columns-popular, .learn-meganav-columns'
    ));
  }

  getColumnLinks(column) {
    return Array.from(column.querySelectorAll('a[href]')).filter((link) => {
      const href = link.getAttribute('href');
      const id = link.getAttribute('id');
      return href && href !== '#' && href !== '' && !id?.includes('close-');
    });
  }

  findLinkColumn(meganavType, link) {
    const columns = this.getColumns(meganavType);
    return columns.find(column => column.contains(link));
  }

  navigateToAdjacentColumn(meganavType, currentLink, direction) {
    const columns = this.getColumns(meganavType);
    if (columns.length <= 1) return;

    const currentColumn = this.findLinkColumn(meganavType, currentLink);
    if (!currentColumn) return;

    const currentColumnIndex = columns.indexOf(currentColumn);
    const currentColumnLinks = this.getColumnLinks(currentColumn);
    const currentLinkIndex = currentColumnLinks.indexOf(currentLink);

    let targetColumn;
    if (direction === 'next') {
      targetColumn = columns[currentColumnIndex + 1] || columns[0];
    } else {
      targetColumn = columns[currentColumnIndex - 1] || columns[columns.length - 1];
    }

    const targetColumnLinks = this.getColumnLinks(targetColumn);
    if (targetColumnLinks.length === 0) return;

    const targetIndex = Math.min(currentLinkIndex, targetColumnLinks.length - 1);
    targetColumnLinks[targetIndex].focus();
  }
}

